<template>
<body>
  <div id="app">
    <!-- <keep-alive v-if="this.$route.meta.keepAlive === true">
      <router-view ></router-view>
    </keep-alive> -->
    <router-view ></router-view>
  </div>
</body>
</template>

<script>
export default {
  created() {
    // console.log(this.$router);
    // 首页加载
    // let loading = document.getElementById("loading");
    // console.log(loading);
    // if (loading != null) {
    //   document.body.removeChild(loading);
    // }
    //页面渲染完后执行以下函数
    // 阻止双击放大
    document.documentElement.addEventListener(
      "touchstart",
      function(event) {
        if (event.touches.length > 1) {
          event.preventDefault();
        }
      },
      false
    );
    var lastTouchEnd = 0;
    document.documentElement.addEventListener(
      "touchend",
      function(event) {
        var now = Date.now();
        if (now - lastTouchEnd <= 300) {
          event.preventDefault();
        }
        lastTouchEnd = now;
      },
      false
    );
    // 阻止双指放大
    document.documentElement.addEventListener("gesturestart", function(event) {
      event.preventDefault();
    });
  }
};
</script>

<style >
* {
  margin: 0;
  padding: 0;
  list-style: none;
}
.ht {
  height: 100%;
}
html,
body,
#app {
  overflow-y: auto;
  height: 100%;
  background: rgba(242, 242, 242, 1);
}

::-webkit-scrollbar {
  background-color: transparent;
}
#app::-webkit-scrollbar {
  display: none;
} 
</style>